var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useEffect, useRef, useState } from "react";
import { DEFAULT_CONSTRAINTS } from "./constants";
import { useBrowserMultiFormatReader } from "./useBrowserMultiFormatReader";
import { useTorch } from "./useTorch";
import { deepCompareObjects } from "./utils";
export var useZxing = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.paused, paused = _a === void 0 ? false : _a, hints = options.hints, timeBetweenDecodingAttempts = options.timeBetweenDecodingAttempts, _b = options.onDecodeResult, onDecodeResult = _b === void 0 ? function () { } : _b, _c = options.onDecodeError, onDecodeError = _c === void 0 ? function () { } : _c, _d = options.onError, onError = _d === void 0 ? function () { } : _d;
    var deviceId = "deviceId" in options ? options.deviceId : undefined;
    var _e = useState("constraints" in options ? options.constraints : undefined), constraints = _e[0], setConstraints = _e[1];
    var decodeResultHandlerRef = useRef(onDecodeResult);
    var decodeErrorHandlerRef = useRef(onDecodeError);
    var errorHandlerRef = useRef(onError);
    var ref = useRef(null);
    var reader = useBrowserMultiFormatReader({
        hints: hints,
        timeBetweenDecodingAttempts: timeBetweenDecodingAttempts,
    });
    var _f = useTorch({
        resetStream: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stopDecoding();
                        return [4 /*yield*/, startDecoding()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    }), torchInit = _f.init, torch = __rest(_f, ["init"]);
    var decodeCallback = useCallback(function (result, error) {
        if (result)
            decodeResultHandlerRef.current(result);
        if (error)
            decodeErrorHandlerRef.current(error);
    }, []);
    var startDecoding = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1, mediaStream, videoTrack;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ref.current)
                        return [2 /*return*/];
                    if (paused)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 7]);
                    if (!deviceId) return [3 /*break*/, 3];
                    return [4 /*yield*/, reader.decodeFromVideoDevice(deviceId, ref.current, decodeCallback)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, reader.decodeFromConstraints(constraints !== null && constraints !== void 0 ? constraints : DEFAULT_CONSTRAINTS, ref.current, decodeCallback)];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 7];
                case 6:
                    e_1 = _a.sent();
                    errorHandlerRef.current(e_1);
                    return [2 /*return*/];
                case 7:
                    if (!ref.current)
                        return [2 /*return*/];
                    mediaStream = ref.current.srcObject;
                    videoTrack = mediaStream.getVideoTracks()[0];
                    if (videoTrack)
                        torchInit(videoTrack);
                    return [2 /*return*/];
            }
        });
    }); }, [reader, deviceId, constraints, paused, decodeCallback, torchInit]);
    var stopDecoding = useCallback(function () {
        reader.reset();
    }, [reader]);
    useEffect(function () {
        decodeResultHandlerRef.current = onDecodeResult;
    }, [onDecodeResult]);
    useEffect(function () {
        decodeErrorHandlerRef.current = onDecodeError;
    }, [onDecodeError]);
    useEffect(function () {
        errorHandlerRef.current = onError;
    }, [onError]);
    useEffect(function () {
        var isConstraintsValueSame = deepCompareObjects(constraints, options.constraints);
        if (!isConstraintsValueSame) {
            setConstraints(options.constraints);
        }
    }, [constraints, options]);
    useEffect(function () {
        startDecoding();
        return function () {
            stopDecoding();
        };
    }, [startDecoding, stopDecoding]);
    return {
        ref: ref,
        torch: torch,
    };
};
